import { post, put, get } from 'axios'

const CONFIRM_INVITE_ROUTE = 'users/confirm/'

// initial state
function initialState() {
  return {
    confirmInvite: {
      form: {
        password: undefined,
        email: undefined,
        googleRecaptcha: undefined,
        token: undefined,
        secretQuestion: undefined,
        secretQuestionAnswer: undefined,
      },
      message: undefined,
      submitInProgress: false,
    },
  }
}

function formatToSend(data) {
  const {
    password,
    token: authToken,
    secretQuestion,
    secretQuestionAnswer,
  } = data
  return {
    password,
    authToken,
    secretQuestion,
    secretQuestionAnswer,
  }
}

const state = initialState()

// getters
const getters = {
  confirmInvite: state => state.confirmInvite,
}

// actions
const actions = {
  confirmInvite({ state }) {
    const dataFormated = formatToSend(state.confirmInvite.form)

    return put(CONFIRM_INVITE_ROUTE, dataFormated).then(() => {
      const {
        password,
        email,
        googleRecaptcha,
        token,
      } = state.confirmInvite.form
      return post('/auth/login', {
        password,
        email,
        googleRecaptcha,
        token,
      }).then(response => {
        return response.data.token
      })
    })
  },

  checkConfirmed(_, token) {
    return get(`${CONFIRM_INVITE_ROUTE}${token}`).then(response => {
      return response.data
    })
  },

  updateMessage(state, message) {
    state.confirmInvite.message = message
  },

  requestData() {
    return get(CONFIRM_INVITE_ROUTE + '/' + this.$route.params.token)
  },

  clearPassword(state) {
    state.confirmInvite.form.password = undefined
  },

  // eslint-disable-next-line no-unused-vars
  reset({ state }) {
    state = initialState()
  },
}

const mutations = {
  updateConfirmInviteForm(state, properties) {
    state.confirmInvite.form[properties.property] = properties.value
  },
  updateMessage(state, message) {
    state.confirmInvite.message = message
  },

  saveJWT(state, jwt) {
    localStorage.jwt = jwt
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
